import React, { useState } from 'react'
import Advantages from './Advantages/Advantages'
import Analysis from './Analysis/Analysis'
import Build from './Build/Build'
import Competence from './Competence/Competence'
import Contact from './Contact/Contact'
import Design from './Design/Design'
import FAQ from './FAQ/FAQ'
import Highlights from './Highlights'
import Intro, { IntroActiveId } from './Intro/Intro'
import Footer from './Footer'
import Header from './HeaderNew'
import Processes from './Processes/Processes'
import Team from './Team'
import Timeline from './Timeline/Timeline'

function Landing() {
  const [activeId, setActiveId] = useState<IntroActiveId>(null)
  return (
    <div className="bg-white text-blue">
      <Header resetActiveId={() => setActiveId(null)} />
      <Intro activeId={activeId} setActiveId={setActiveId} />
      <Advantages />
      <Timeline />
      <FAQ />
      <Highlights />
      <Competence />
      <Processes />
      <Analysis />
      <Design />
      <Build />
      <Team />
      <Contact />
      <Footer />
    </div>
  )
}

export default Landing
